var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1385_488)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "url(#paint0_linear_1385_488)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.3749C7.1044 21.9741 7.21264 21.5748 7.3132 21.1732C7.53198 20.3023 7.74462 19.43 7.96878 18.5607C7.99565 18.4563 8.05552 18.3457 8.13152 18.2697C11.1069 15.2895 14.0854 12.313 17.0639 9.33511C17.6527 8.74612 18.2392 8.15484 18.8311 7.56892C19.5987 6.8087 20.7456 6.811 21.5148 7.572C21.818 7.87225 22.1197 8.17403 22.4206 8.47736C23.1944 9.25909 23.1936 10.4056 22.4152 11.185C18.927 14.6759 15.435 18.163 11.9529 21.66C11.7065 21.908 11.4409 22.0501 11.1054 22.1292C9.97926 22.3949 8.85926 22.6836 7.73695 22.9647C7.70854 22.9716 7.68321 22.9877 7.65634 23H7.37538C7.20113 22.9247 7.08214 22.7934 7.00077 22.6253C7.00077 22.5423 7.00077 22.4586 7.00077 22.3757L7 22.3749ZM17.5675 10.3372C14.794 13.1117 12.0105 15.8953 9.25306 18.6537C9.95086 19.3517 10.6625 20.0628 11.3587 20.7592C14.1231 17.9948 16.9035 15.2134 19.6747 12.4413C18.9754 11.7425 18.2653 11.0337 17.5683 10.3365L17.5675 10.3372ZM20.4531 11.7018C20.8676 11.2871 21.2853 10.8732 21.6975 10.4555C22.0729 10.0754 22.0698 9.57546 21.6936 9.19458C21.4012 8.89894 21.1072 8.60483 20.8116 8.31226C20.4163 7.92139 19.9257 7.92446 19.5296 8.3184C19.1504 8.69621 18.772 9.07556 18.3935 9.45413C18.3582 9.48946 18.3267 9.52785 18.3045 9.55243C19.0245 10.2727 19.7331 10.9815 20.4531 11.7018ZM10.2978 21.2699C9.77046 20.7424 9.25383 20.2271 8.73336 19.7065C8.56448 20.3837 8.39252 21.0749 8.21443 21.7898C8.92758 21.6116 9.6177 21.4396 10.2978 21.2699Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1385_488",
    x: -30,
    y: -30,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1385_488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1385_488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_488",
    x1: 2,
    y1: 2,
    x2: 45.0352,
    y2: 56.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.99b03dfabf17ba22eebeb298fa4da3d1.svg";
export { ForwardRef as ReactComponent };